import React, { FC } from 'react';
import { Alert, Button } from 'drift-ui';
import css from './PrefillBanner.scss';
import { useTranslation } from 'react-i18next';
import Config from 'Config';

type PrefillBannerProps = {
  hasLockedFields: boolean;
  isOwnershipSection?: boolean;
};

export const PrefillBanner: FC<PrefillBannerProps> = ({ hasLockedFields, isOwnershipSection }) => {
  const { t } = useTranslation();

  const navigateToContactUs = () => {
    window.open(`${Config.adminWebUrl}contact-us/`, '_blank');
  };
  return (
    <Alert
      className={css.bannerContainer}
      action={
        hasLockedFields && (
          <Button onClick={navigateToContactUs} variant="text">
            {t('digital_onboarding.prepopulation.contact_us')}
          </Button>
        )
      }
    >
      <p className={css.text}>
        {isOwnershipSection
          ? t('digital_onboarding.prepopulation.owner_text')
          : t('digital_onboarding.prepopulation.business_text')}
      </p>
      {hasLockedFields && <p className={css.lockedText}>{t('digital_onboarding.prepopulation.locked_text')}</p>}
    </Alert>
  );
};
